import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import { noop } from 'lodash';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import moment from 'moment';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';
import t, { markdown } from 'translations';
import Icon from 'components/icon';
import Notification from 'components/notification';
import { BOOSTER_BAR_DELIVERY_DATE, TIME_FORMAT } from 'constants/timeformat';
import { accordionEasingFn, accordionSpeed } from 'constants/transitions-props';
import {
    NOTIFICATION_TYPE_PICKING,
    NOTIFICATION_TYPE_PROMOTION,
    NOTIFICATION_TYPE_SEARCHING,
} from 'constants/notifications';
import Countdown from 'components/countdown';
import staticAssetsPath from 'util/misc/static-assets-path';

function formatDate({ delivery_start, delivery_end }) {
    const start = moment(delivery_start);
    const end = moment(delivery_end);


    return {
        delivery_day: start.format(BOOSTER_BAR_DELIVERY_DATE),
        delivery_time: `${ start.format(TIME_FORMAT) }-${ end.format(TIME_FORMAT) }`,
    };
}

export default class BoosterBarItem extends PureComponent {
    static defaultProps = {
        onRemove: noop,
    };

    static propTypes = {
        type: PropTypes.string.isRequired,
        has_close: PropTypes.bool.isRequired,
        teaser: PropTypes.string.isRequired,
        onRemove: PropTypes.func.isRequired,
        detail: PropTypes.string,
        data: PropTypes.object,
        link: PropTypes.object,
    };

    state = {
        isOpen: false,
    };

    hasCountdownComponent(props) {
        return props.type === NOTIFICATION_TYPE_PROMOTION && props.data && props.data.deadline;
    }

    getIconProps() {
        const { type } = this.props;
        const props = {
            symbol: null,
            size: 'medium',
        };

        switch (type) {
            case NOTIFICATION_TYPE_PROMOTION:
                props.symbol = 'gift';
                break;
            case NOTIFICATION_TYPE_SEARCHING:
                props.symbol = 'clock';
                break;
            default:
                props.symbol = 'list';
                break;
        }

        return props;
    }

    doAction = () => {
        const { has_close } = this.props;

        if (has_close) {
            this.props.onRemove();
        }
    };

    renderAction() {
        const { detail, has_close } = this.props;
        const { isOpen } = this.state;

        if (!detail && !has_close) {
            return null;
        }

        return has_close ? <Icon symbol="cancel-extra-small" size="small"/> :
            <Icon symbol={ isOpen ? 'basket-remove' : 'basket-add' } size="small"/>;
    }

    renderNotificationHeader() {
        const { data, type } = this.props;
        const hasCountdown = this.hasCountdownComponent(this.props);

        if (hasCountdown) {
            return (
                <div className="booster-bar--countdown">
                    <Countdown startDate={ data.now } endDate={ data.deadline }
                        rootFacet="booster-bar" facet="booster-bar"/>
                </div>
            );
        }


        if (type === NOTIFICATION_TYPE_PROMOTION) {
            return (
                <div className="booster-bar--icon">
                    <img src={ staticAssetsPath('img/notifications/present.svg') }/>
                </div>
            );
        }


        return (
            <div className="booster-bar--icon">
                <Icon { ...this.getIconProps() }/>
            </div>
        );
    }

    renderContent() {
        const { link, teaser, data, type } = this.props;

        if (type === NOTIFICATION_TYPE_PICKING) {
            Object.assign(data, formatDate(data));
        }

        return (
            <div className="booster-bar--row">
                { this.renderNotificationHeader() }

                <div className="booster-bar--text">
                    <p className="booster-bar--paragraph"
                        dangerouslySetInnerHTML={ { __html: markdown(teaser, data) } }>
                    </p>
                    { link ? <Link className="booster-bar--link u-reset"
                        to={ normaliseTrailingSlash(link.url) }>{ t(link.text) }</Link> : null }
                </div>
                <div className="booster-bar--action" onClick={ this.doAction }>
                    { this.renderAction() }
                </div>
            </div>
        );
    }

    render() {
        const { type, detail } = this.props;
        const notificationFacet = type === NOTIFICATION_TYPE_PROMOTION ? 'promotion' : 'blank';

        return (
            <li className={ classnames('booster-bar--item', `booster-bar--item__${ type }`, {
                'booster-bar--item__has-countdown': this.hasCountdownComponent(this.props),
            }) }>
                <Notification facet={ notificationFacet }>
                    { detail ?
                        <Collapsible triggerClassName="booster-bar--trigger"
                            transitionTime={ accordionSpeed }
                            easing={ accordionEasingFn }
                            onOpen={ () => this.setState({ isOpen: true }) }
                            onClose={ () => this.setState({ isOpen: false }) } trigger={ this.renderContent() }>
                            <p className="booster-bar--accordion-content"
                                dangerouslySetInnerHTML={ { __html: markdown(detail) } }/>
                        </Collapsible> : this.renderContent() }
                </Notification>
            </li>
        );
    }
}





// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/booster-bar/item/index.js